/**
 * Utilities for building the Classes worksheet in Excel
 */

import ExcelJS from "exceljs";

import type { ExcelRow } from "../rates";

const isHeaderRow = (index: number): boolean => index === 0;
const isColumnHeaderRow = (index: number): boolean => index === 1;

const autoFitColumns = (worksheet: ExcelJS.Worksheet): void => {
  worksheet.columns.forEach((column) => {
    let maxLength = 10;
    column.eachCell?.({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value?.toString() || "";
      if (cellValue.length > maxLength) {
        maxLength = cellValue.length;
      }
    });
    column.width = Math.min(maxLength + 2, 50);
  });
};

const addRow = (
  worksheet: ExcelJS.Worksheet,
  rowData: ExcelRow,
  isHeader: boolean,
): void => {
  const values = [rowData.label, ...Object.values(rowData.values)];
  const row = worksheet.addRow(values);

  if (isHeader) {
    row.font = { bold: true };
  } else {
    row.getCell(1).font = { bold: true };
  }

  row.alignment = { horizontal: "left", vertical: "middle" };
};

export const buildClassesWorksheet = (
  workbook: ExcelJS.Workbook,
  rows: ExcelRow[],
): void => {
  const worksheet = workbook.addWorksheet("Classes");

  rows.forEach((row, index) => {
    if (isHeaderRow(index)) {
      const headerRow = worksheet.addRow([row.label]);
      headerRow.font = { bold: true, size: 14 };
      headerRow.alignment = { horizontal: "left", vertical: "middle" };
    } else {
      addRow(worksheet, row, isColumnHeaderRow(index));
    }
  });

  autoFitColumns(worksheet);

  const sheets = workbook.worksheets;
  const classesIndex = sheets.indexOf(worksheet);
  if (classesIndex > 0) {
    sheets.splice(classesIndex, 1);
    sheets.unshift(worksheet);
  }
};
